/* eslint-disable */
export default {
  createLog: '创建记录',
  creating: '正在创建',
  save: '保存',
  saving: '正在保存',
  saved: '已保存',
  view: '查看',
  creatingFailed: '创建失败。',
  savingFailed: '保存失败。',
} as const;

// @key: @#@"createLog"@#@ @source: @#@"Create Log"@#@
// @key: @#@"creating"@#@ @source: @#@"Creating"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
// @key: @#@"saving"@#@ @source: @#@"Saving"@#@
// @key: @#@"saved"@#@ @source: @#@"Saved"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"creatingFailed"@#@ @source: @#@"Creating failed."@#@
// @key: @#@"savingFailed"@#@ @source: @#@"Saving failed."@#@
